var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    rx: 56,
    fill: "white",
    fillOpacity: 0.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2404_1227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.8652 84.3843C85.8652 87.5163 84.6983 90.2622 82.8249 92.3683C82.8028 92.3931 82.7874 92.4233 82.7806 92.4559C82.7524 92.5906 82.873 92.7091 83.0066 92.6762C88.4087 91.3451 92.7765 86.7307 92.7765 80.6711V49.2575C92.7765 39.9714 87.5897 31.3907 79.1699 26.7477L45.1726 8L38.438 11.8106L72.2587 30.4608C80.6784 35.1039 85.8652 43.6846 85.8652 52.9707V84.3843Z",
    fill: "url(#paint0_linear_2404_1227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8652 84.3843C85.8652 87.5163 84.6983 90.2622 82.8249 92.3683C82.8028 92.3931 82.7874 92.4233 82.7806 92.4559C82.7524 92.5906 82.873 92.7091 83.0066 92.6762C88.4087 91.3451 92.7765 86.7307 92.7765 80.6711V49.2575C92.7765 39.9714 87.5897 31.3907 79.1699 26.7477L45.1726 8L38.438 11.8106L72.2587 30.4608C80.6784 35.1039 85.8652 43.6846 85.8652 52.9707V84.3843Z",
    fill: "url(#paint1_linear_2404_1227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8652 84.3843C85.8652 87.5163 84.6983 90.2622 82.8249 92.3683C82.8028 92.3931 82.7874 92.4233 82.7806 92.4559C82.7524 92.5906 82.873 92.7091 83.0066 92.6762C88.4087 91.3451 92.7765 86.7307 92.7765 80.6711V49.2575C92.7765 39.9714 87.5897 31.3907 79.1699 26.7477L45.1726 8L38.438 11.8106L72.2587 30.4608C80.6784 35.1039 85.8652 43.6846 85.8652 52.9707V84.3843Z",
    fill: "url(#paint2_radial_2404_1227)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8652 84.3843C85.8652 87.5163 84.6983 90.2622 82.8249 92.3683C82.8028 92.3931 82.7874 92.4233 82.7806 92.4559C82.7524 92.5906 82.873 92.7091 83.0066 92.6762C88.4087 91.3451 92.7765 86.7307 92.7765 80.6711V49.2575C92.7765 39.9714 87.5897 31.3907 79.1699 26.7477L45.1726 8L38.438 11.8106L72.2587 30.4608C80.6784 35.1039 85.8652 43.6846 85.8652 52.9707V84.3843Z",
    fill: "url(#paint3_radial_2404_1227)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8652 84.3843C85.8652 87.5163 84.6983 90.2622 82.8249 92.3683C82.8028 92.3931 82.7874 92.4233 82.7806 92.4559C82.7524 92.5906 82.873 92.7091 83.0066 92.6762C88.4087 91.3451 92.7765 86.7307 92.7765 80.6711V49.2575C92.7765 39.9714 87.5897 31.3907 79.1699 26.7477L45.1726 8L38.438 11.8106L72.2587 30.4608C80.6784 35.1039 85.8652 43.6846 85.8652 52.9707V84.3843Z",
    fill: "url(#paint4_linear_2404_1227)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3622 89.7478V58.3342C76.3622 49.0482 71.1754 40.4674 62.7557 35.8244L28.9351 17.1741L35.6697 13.3635L69.6669 32.1112C78.0867 36.7543 83.2735 45.335 83.2735 54.6211V86.0347C83.2735 92.0942 78.9057 96.7087 73.5036 98.0398C73.37 98.0727 73.2494 97.9541 73.2776 97.8195C73.2845 97.7869 73.2998 97.7567 73.3219 97.7318C75.1954 95.6258 76.3622 92.8799 76.3622 89.7478Z",
    fill: "url(#paint5_linear_2404_1227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3622 89.7478V58.3342C76.3622 49.0482 71.1754 40.4674 62.7557 35.8244L28.9351 17.1741L35.6697 13.3635L69.6669 32.1112C78.0867 36.7543 83.2735 45.335 83.2735 54.6211V86.0347C83.2735 92.0942 78.9057 96.7087 73.5036 98.0398C73.37 98.0727 73.2494 97.9541 73.2776 97.8195C73.2845 97.7869 73.2998 97.7567 73.3219 97.7318C75.1954 95.6258 76.3622 92.8799 76.3622 89.7478Z",
    fill: "url(#paint6_linear_2404_1227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3622 89.7478V58.3342C76.3622 49.0482 71.1754 40.4674 62.7557 35.8244L28.9351 17.1741L35.6697 13.3635L69.6669 32.1112C78.0867 36.7543 83.2735 45.335 83.2735 54.6211V86.0347C83.2735 92.0942 78.9057 96.7087 73.5036 98.0398C73.37 98.0727 73.2494 97.9541 73.2776 97.8195C73.2845 97.7869 73.2998 97.7567 73.3219 97.7318C75.1954 95.6258 76.3622 92.8799 76.3622 89.7478Z",
    fill: "url(#paint7_radial_2404_1227)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3622 89.7478V58.3342C76.3622 49.0482 71.1754 40.4674 62.7557 35.8244L28.9351 17.1741L35.6697 13.3635L69.6669 32.1112C78.0867 36.7543 83.2735 45.335 83.2735 54.6211V86.0347C83.2735 92.0942 78.9057 96.7087 73.5036 98.0398C73.37 98.0727 73.2494 97.9541 73.2776 97.8195C73.2845 97.7869 73.2998 97.7567 73.3219 97.7318C75.1954 95.6258 76.3622 92.8799 76.3622 89.7478Z",
    fill: "url(#paint8_radial_2404_1227)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3622 89.7478V58.3342C76.3622 49.0482 71.1754 40.4674 62.7557 35.8244L28.9351 17.1741L35.6697 13.3635L69.6669 32.1112C78.0867 36.7543 83.2735 45.335 83.2735 54.6211V86.0347C83.2735 92.0942 78.9057 96.7087 73.5036 98.0398C73.37 98.0727 73.2494 97.9541 73.2776 97.8195C73.2845 97.7869 73.2998 97.7567 73.3219 97.7318C75.1954 95.6258 76.3622 92.8799 76.3622 89.7478Z",
    fill: "url(#paint9_linear_2404_1227)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 22.7933L25.8224 18.9331L59.8196 37.6808C68.2394 42.3238 73.4262 50.9045 73.4262 60.1906V91.7591L73.4253 91.7586C73.3094 101.196 62.5806 107.061 53.9883 102.323L23.1756 85.3317L19 83.0883V22.7933ZM66.5149 64.0018V82.2385L43.6214 69.6139V36.3707L52.9084 41.492C61.3282 46.135 66.5149 54.7157 66.5149 64.0018ZM34.9823 31.6067L38.4379 33.5123V72.4705L38.8007 72.665L66.5149 87.9479V91.476L35.0269 74.112L34.9823 74.1372V31.6067ZM29.3669 28.5101V77.1339L29.5293 77.2226L29.3669 77.3145L66.4725 97.7762C66.1623 99.4082 64.213 100.339 62.6273 99.4648L25.9113 79.2178V26.6045L29.3669 28.5101Z",
    fill: "url(#paint10_linear_2404_1227)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 22.7933L25.8224 18.9331L59.8196 37.6808C68.2394 42.3238 73.4262 50.9045 73.4262 60.1906V91.7591L73.4253 91.7586C73.3094 101.196 62.5806 107.061 53.9883 102.323L23.1756 85.3317L19 83.0883V22.7933ZM66.5149 64.0018V82.2385L43.6214 69.6139V36.3707L52.9084 41.492C61.3282 46.135 66.5149 54.7157 66.5149 64.0018ZM34.9823 31.6067L38.4379 33.5123V72.4705L38.8007 72.665L66.5149 87.9479V91.476L35.0269 74.112L34.9823 74.1372V31.6067ZM29.3669 28.5101V77.1339L29.5293 77.2226L29.3669 77.3145L66.4725 97.7762C66.1623 99.4082 64.213 100.339 62.6273 99.4648L25.9113 79.2178V26.6045L29.3669 28.5101Z",
    fill: "url(#paint11_linear_2404_1227)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 22.7933L25.8224 18.9331L59.8196 37.6808C68.2394 42.3238 73.4262 50.9045 73.4262 60.1906V91.7591L73.4253 91.7586C73.3094 101.196 62.5806 107.061 53.9883 102.323L23.1756 85.3317L19 83.0883V22.7933ZM66.5149 64.0018V82.2385L43.6214 69.6139V36.3707L52.9084 41.492C61.3282 46.135 66.5149 54.7157 66.5149 64.0018ZM34.9823 31.6067L38.4379 33.5123V72.4705L38.8007 72.665L66.5149 87.9479V91.476L35.0269 74.112L34.9823 74.1372V31.6067ZM29.3669 28.5101V77.1339L29.5293 77.2226L29.3669 77.3145L66.4725 97.7762C66.1623 99.4082 64.213 100.339 62.6273 99.4648L25.9113 79.2178V26.6045L29.3669 28.5101Z",
    fill: "url(#paint12_radial_2404_1227)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 22.7933L25.8224 18.9331L59.8196 37.6808C68.2394 42.3238 73.4262 50.9045 73.4262 60.1906V91.7591L73.4253 91.7586C73.3094 101.196 62.5806 107.061 53.9883 102.323L23.1756 85.3317L19 83.0883V22.7933ZM66.5149 64.0018V82.2385L43.6214 69.6139V36.3707L52.9084 41.492C61.3282 46.135 66.5149 54.7157 66.5149 64.0018ZM34.9823 31.6067L38.4379 33.5123V72.4705L38.8007 72.665L66.5149 87.9479V91.476L35.0269 74.112L34.9823 74.1372V31.6067ZM29.3669 28.5101V77.1339L29.5293 77.2226L29.3669 77.3145L66.4725 97.7762C66.1623 99.4082 64.213 100.339 62.6273 99.4648L25.9113 79.2178V26.6045L29.3669 28.5101Z",
    fill: "url(#paint13_radial_2404_1227)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 22.7933L25.8224 18.9331L59.8196 37.6808C68.2394 42.3238 73.4262 50.9045 73.4262 60.1906V91.7591L73.4253 91.7586C73.3094 101.196 62.5806 107.061 53.9883 102.323L23.1756 85.3317L19 83.0883V22.7933ZM66.5149 64.0018V82.2385L43.6214 69.6139V36.3707L52.9084 41.492C61.3282 46.135 66.5149 54.7157 66.5149 64.0018ZM34.9823 31.6067L38.4379 33.5123V72.4705L38.8007 72.665L66.5149 87.9479V91.476L35.0269 74.112L34.9823 74.1372V31.6067ZM29.3669 28.5101V77.1339L29.5293 77.2226L29.3669 77.3145L66.4725 97.7762C66.1623 99.4082 64.213 100.339 62.6273 99.4648L25.9113 79.2178V26.6045L29.3669 28.5101Z",
    fill: "url(#paint14_linear_2404_1227)",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2404_1227",
    x1: 17.7716,
    y1: 56,
    x2: 91.9535,
    y2: 49.3683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2404_1227",
    x1: 23.5727,
    y1: 12.4181,
    x2: 75.3636,
    y2: 56.4163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2404_1227",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.9452 41.7465) rotate(65.584) scale(21.5051 18.4545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.925861,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2404_1227",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.6602 32.8437) rotate(59.0024) scale(13.6496 18.6422)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0864251,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94115,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2404_1227",
    x1: 27.4458,
    y1: 34.6642,
    x2: 65.8816,
    y2: 48.2331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2404_1227",
    x1: 17.7716,
    y1: 56.0001,
    x2: 91.9535,
    y2: 49.3684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2404_1227",
    x1: 23.5727,
    y1: 12.4182,
    x2: 75.3636,
    y2: 56.4164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2404_1227",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.9452 41.7466) rotate(65.584) scale(21.5051 18.4545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.925861,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2404_1227",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.6602 32.8438) rotate(59.0024) scale(13.6496 18.6422)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0864251,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94115,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2404_1227",
    x1: 27.4458,
    y1: 34.6643,
    x2: 65.8816,
    y2: 48.2332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2404_1227",
    x1: 17.7715,
    y1: 55.9999,
    x2: 91.9534,
    y2: 49.3682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2404_1227",
    x1: 23.5726,
    y1: 12.418,
    x2: 75.3635,
    y2: 56.4162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2404_1227",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.9451 41.7464) rotate(65.584) scale(21.5051 18.4545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.925861,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2404_1227",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.6601 32.8436) rotate(59.0024) scale(13.6496 18.6422)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0864251,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94115,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2404_1227",
    x1: 27.4457,
    y1: 34.6641,
    x2: 65.8815,
    y2: 48.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2404_1227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 96,
    fill: "white",
    transform: "translate(19 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrift);
export default __webpack_public_path__ + "static/media/DRIFT.a824fb03be77e14c32f5bff7b5d00f23.svg";
export { ForwardRef as ReactComponent };